(() => {
  const initialise = (nav) => {
    if (nav.dataset.olScrollNavReady === 'true') return;

    const track = document.getElementById(nav.dataset.target);
    if (!track) return;

    const previous = nav.querySelector('[data-direction="-1"]');
    const next = nav.querySelector('[data-direction="1"]');
    if (!previous || !next) return;

    nav.dataset.olScrollNavReady = 'true';

    const update = () => {
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-direction]');
      if (!button) return;
      const direction = Number(button.dataset.direction);
      track.scrollBy({
        left: direction * Math.max(240, track.clientWidth * 0.86),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const start = (scope = document) => {
    if (scope.matches?.('[data-ol-scroll-nav]')) initialise(scope);
    scope.querySelectorAll?.('[data-ol-scroll-nav]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
